/**
 * Interakce uživatele s mapou.
 */
enum MapInteractionType {
    /**
     * Začátek posuvu mapy tažením myší nebo dotykem.
     */
    DRAG_PAN_STARTED = 'DRAG_PAN_STARTED',

    /**
     * Konec posuvu mapy tažením myší nebo dotykem.
     */
    DRAG_PAN_FINISHED = 'DRAG_PAN_FINISHED',

    /**
     * Výběr výsledku hledání z lokalit.
     */
    LOCATION_SEARCH_RESULT_SELECTED = 'LOCATION_SEARCH_RESULT_SELECTED',

    /**
     * Výběr výsledku hledání z features ve vrstvách.
     */
    FEATURE_SEARCH_RESULT_SELECTED = 'FEATURE_SEARCH_RESULT_SELECTED',
}

export default MapInteractionType;
